/**
 * ラウター用モジュール
 *
 * @module app/control/AdisRouter
 */
define(['module',
    'dojo/_base/declare',
    'dojo/_base/lang',
    'idis/control/Router',
    'idis/model/UserInfo',
    'src/modules/index.js'
], function (module, declare, lang, Router, UserInfo) {
    /**
     * ラウター
     *
     * @class AdisRouter
     * @extends module:idis/control/Router~Router
     */
    return declare(module.id.replace(/\//g, '.'), Router, /** @lends app/control/AdisRouter */
        {
            // 初期化処理
            init: function () {
                // ユーザ情報に応じてURLのマッピングを登録
                return UserInfo.load().then(lang.hitch(this, function () {

                    var trainingFlg = UserInfo.isTrainingFlg();
                    console.debug('訓練モード : ' + trainingFlg);

                    // デフォルト画面の設定
                    this.register('app/signage/SignageAdminPage');

                    // FIXNE: 一時的に追加（後で消す）
                    this.register({
                        'monitoring': 'app/view/page/MonitoringPage',
                    });

                    // ログイン
                    this.register({
                        'login': 'app/login/view/LoginPage',
                        'login/training': 'app/login/view/TrainingLoginPage'
                    });

                    // デジタルサイネージ
                    if (UserInfo.hasAuthz('F14001')) {
                        this.register({
                            'signageMapSetting': 'app/signage/SignageMapSettingPage',
                        });
                    }
                    if (UserInfo.hasAuthz('F14002')) {
                        this.register({
                            'signage': 'app/signage/SignageAdminPage',
                            'signage/disasterPreventionStatusSignage': 'app/signage/display/SignageDisasterPreventionStatusPage',
                            'signage/damageOverviewSignage': 'app/signage/display/SignageDamageOverviewPage',
                            'signage/damageListSignage': 'app/signage/display/SignageDamageListPage',
                            'signage/shelterOverviewSignage': 'app/signage/display/SignageShelterOverviewPage',
                            'signage/shelterListSignage': 'app/signage/display/SignageShelterListPage',
                            'signage/evacOrderOverviewSignage': 'app/signage/display/SignageEvacOrderOverviewPage',
                            'signage/evacOrderHistorySignage': 'app/signage/display/SignageEvacOrderHistory',
                            'signage/mapSignage': 'app/signage/display/SignageMapPage',
                            'signage/thematicEvacuationSignage': 'app/signage/display/SignageThematicEvacPage',
                            'signage/chronologyOverviewSignage': 'app/signage/display/SignageChronologyOverviewPage',
                            'signage/chronologyListSignage': 'app/signage/display/SignageChronologyListPage',
                            'signage/disasterPreventionOverview': 'app/signage/display/SignageDisasterPreventionOverviewPage',
                            'signage/lifelineOverviewSignage': 'app/signage/display/SignageLifelineOverviewPage',
                            'signage/observationOverviewSignage': 'app/signage/display/SignageObservationOverviewPage',
                            'signage/earthquakeStatusSignage': 'app/signage/display/SignageEarthquakeStatusPage',
                            'signage/weatherInfoStatusSignage': 'app/signage/display/SignageWeatherInfoStatusPage'
                        });
                    }

                    // ユーザ情報が取れない場合は常にログイン・ページを表示
                }), lang.hitch(this, function () {
                    // 本番用ログイン
                    this.register({
                        '': 'app/login/view/LoginPage',
                        'login': 'app/login/view/LoginPage',
                        'login/training': 'app/login/view/TrainingLoginPage'
                    });

                }));
            }
        });
});
